import { useState } from 'react'
import { Button, Dialog, IconButton } from '@mui/material'
import { RichTestField } from './RichTestField'
import CloseIcon from '@mui/icons-material/Close'

export const RichTestFieldWidget = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Rich Test Field
      </Button>

      <Dialog fullScreen open={open} onClose={() => setOpen(false)}>
        <IconButton onClick={() => setOpen(false)} sx={{ position: 'absolute', top: 0, right: 0 }}>
          <CloseIcon />
        </IconButton>

        <RichTestField requestClose={() => setOpen(false)} />
      </Dialog>
    </>
  )
}
